import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { HttpLoaderFactory } from 'src/app/core';

import { PipesModule } from '../../pipes/pipes.module';

import { CapacityInfoComponent } from './capacity-info.component';

@NgModule({
  declarations: [CapacityInfoComponent],
  exports: [CapacityInfoComponent],
  imports: [
    CommonModule,
    PipesModule,
    NzToolTipModule,
    InlineSVGModule,
    NzPaginationModule,
    NzCardModule,
    NzProgressModule,
    NzTypographyModule,
    NzDividerModule,
    PipesModule,
    NzToolTipModule,
    NzButtonModule,
    NzDropDownModule,
    NzDrawerModule,
    NzTagModule,
    NzGridModule,
    NzIconModule,
    TranslateModule.forChild({
      extend: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
})
export class CapacityInfoModule {}
